import ContentPopoverEmptyState from '../../../draft-content-transplant/ContentPopoverEmptyState';
import { useIsUngatedForCpqUpgrades } from 'growth-payments-core/auth/gates';
import { getQuotesURL } from 'growth-payments-core/urls/urls';
import { jsx as _jsx } from "react/jsx-runtime";
const quotesArticleUrl = 'https://knowledge.hubspot.com/articles/kcs_article/deals/how-do-i-create-quotes';
const QuotesPopoverEmptyState = () => {
  const isUngatedForCpqUpgrades = useIsUngatedForCpqUpgrades();
  return /*#__PURE__*/_jsx(ContentPopoverEmptyState, {
    image: "quotes",
    title: "draftPlugins.quotes.popover.zeroState.header",
    description: "draftPlugins.quotes.popover.zeroState.description",
    buttonLabel: isUngatedForCpqUpgrades ? 'draftPlugins.quotes.popover.zeroState.buttonCPQ' : 'draftPlugins.quotes.popover.zeroState.button',
    buttonLink: isUngatedForCpqUpgrades ? getQuotesURL() : quotesArticleUrl
  });
};
export default QuotesPopoverEmptyState;